export const COMPLIANCE_PROGRAMS: string[] = [
  "KYC",
  "Screening",
  "AML (US)",
  "AML (Caymans)",
  "AML (Luxembourg)",
] as const;
